var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertisement"},[_c('div',{staticClass:"icon"}),_c('el-tooltip',{attrs:{"effect":"dark","content":_vm.content,"placement":"top"}},[_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }